import { useTranslation } from '@/i18n';
import { useConfirmModal } from '@/components/ConfirmationModal/Base/hooks/useConfirmModal';
import { useMemo } from 'react';

/**
 * Hook for OCR cancellation modal
 * Uses the generic ConfirmModal with OCR-specific configuration
 */
export const useOCRCancelModal = () => {
  const { t } = useTranslation();

  const modalConfig = useMemo(
    () => ({
      title: t('ocr_cancel_modal_title'),
      body: t('ocr_cancel_modal_body'),
      okButtonProps: {
        color: 'danger' as const,
        isSecondary: true,
        children: t('ocr_discard'),
        testId: 'ocr-discard-button',
      },
      cancelButtonProps: {
        isTertiary: true,
        children: t('cancel'),
        testId: 'ocr-cancel-button',
      },
    }),
    [t]
  );

  return useConfirmModal(modalConfig);
};
